<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-close grow" @click="$store.commit('hideCancelAssignment')">
            <i class="material-icons">close</i>
          </div>
          <div class="modal-title">Cancel Assignment</div>
          <div class="modal-limit-instructions">
            We encourage readers to a cancel an assignment as soon as they know
            they won't be able to complete a review by the due date.
            There is no penalty for cancelling at this time.
            <br />
            <br />
            <div v-if="assignment.is_flow_v2">
              When you cancel your assignment, the snaps you were given to read this book
              will be removed.
            </div>
            <br />
            <br />
            <div class="action cancel-assignment" @click="cancelAssignment">Cancel Assignment</div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Back from "../../modules/Back";
import Bus from "../../modules/Bus";

export default {
  name: "CancelAssignment",
  props: ["assignment"],
  components: {},
  methods: {
    async cancelAssignment() {
      console.log("cancelling assignment");
      const response = Back.cancelAssignment(this.assignment);

      this.$store.commit("hideCancelAssignment");

      if (response) {
        this.$toasted.show("Your assignment has been cancelled successfully.", {
          icon: "check_circle",
          position: "bottom-center",
          duration: 3000
        });
        Bus.$emit("UserChanged", null);
        setTimeout(() => {
          this.$router.push("/reader");
        }, 500);
      } else {
        this.$toasted.show(
          "Oops! Something went wrong. Please try again later.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 3000
          }
        );
      }

      // console.log("cancelled assignment", response);
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-title {
  padding: 0.5em;
  padding-left: 30px;
  font-size: 21pt;
  font-weight: 500;
  color: #111;
  text-align: center;
}
.modal-instructions {
  font-size: 12pt;
  color: #111;
  text-align: center;
}
.modal-limit-instructions {
  padding: 60px 120px;
  padding-top: 40px;
  font-size: 13.5pt;
  color: #111;
  text-align: center;
}
.modal-close {
  font-size: 15pt;
  margin-right: 6px;
  padding: 7px 0 0 6.5px;
  width: 36px;
  height: 36px;
  border-radius: 100px;
  float: right;
  position: relative;
  transition: all 0.2s ease-in-out;
}
.modal-close:hover {
  background: #eee;
  transform: scale(1.1);
  cursor: pointer;
}

.find-book {
  background: #fff;
  box-shadow: 0 0 1.5rem rgba(0, 0, 0, 0.14);
  font-family: $font-family;
}

.actions {
  display: flex;
  justify-content: center;
  padding: 4px;
}
.action-selection {
  flex-grow: 0;
  text-align: center;
}
.action-refresh {
  flex-grow: 0;
  flex-basis: 260px;
  margin-left: auto;
  padding-right: 48px;
  text-align: center;
}
.action-refresh-item {
  float: right;
  width: 120px;
  text-align: center;
  border: 0px solid #f3f3f3;
  border-radius: 8px;
  margin: 0 8px;
  padding: 0.4em 0.75em;
  font-size: 12pt;
  color: #777;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
}
.action-refresh-item:hover {
  cursor: pointer;
  color: #999;
}
.action {
  background: #ede7f6;
  color: #9575cd;
}

.confirm-text {
  padding: 0.75em 0 0 0;
  font-size: 11.5pt;
  color: #333;
  text-align: center;
}
.points-text {
  color: darken(#ffa000, 6%);
  font-weight: 700;
}
.book-title {
  color: $color-blue;
  font-weight: 700;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  z-index: 100000;
}

.modal-container {
  z-index: 999999;
  max-width: 1160px;
  height: 400px;
  margin: 0px auto;
  padding: 20px 10px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 2.5rem rgba(0, 0, 0, 0.19);
  transition: all 0.3s ease;
  font-family: "Source Sans Pro";
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

@media (max-width: 1024px) {
  // .modal-mask {
  //   position: absolute !important;
  // }
  .modal-container {
    height: auto;
    width: 100%;
    max-width: 100%;
    padding: 20px 0;
  }

  .modal-title {
    text-align: left;
    font-size: 19pt;
    padding-top: 1px;
    padding-left: 18px;
    padding-right: 0;
  }

  .modal-close {
    float: right !important;
    position: initial !important;
    margin-right: 12px !important;
  }

  .modal-limit-instructions {
    padding: 8px 16px 16px 16px;
  }
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>


